import { render, staticRenderFns } from "./CRUD.operation.vue?vue&type=template&id=4618cba8&"
import script from "./CRUD.operation.vue?vue&type=script&lang=js&"
export * from "./CRUD.operation.vue?vue&type=script&lang=js&"
import style0 from "./CRUD.operation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4618cba8')) {
      api.createRecord('4618cba8', component.options)
    } else {
      api.reload('4618cba8', component.options)
    }
    module.hot.accept("./CRUD.operation.vue?vue&type=template&id=4618cba8&", function () {
      api.rerender('4618cba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Crud/CRUD.operation.vue"
export default component.exports